var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInitializing)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}}):_c('mxs-query-editor',{staticClass:"fill-height"},[_vm._l((_vm.$slots),function(_,slot){return _vm._t(slot,null,{"slot":slot})})],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }